module.exports = __webpack_public_path__ + "img/logo.f924861b.png";